export const homeZh = {
  homeWords: {
    titles: {
      t1: '汇聚全球先进素质教育活动',
      t2: '与超级学霸同台竞技',
      t3: '如何参与我们的活动',
      t4: '成长故事',
      t5: '让孩子在活动中成长蜕变',
      t6: 'BLOOM活动广场',
      t7: '重点项目推荐'
    },
    texts: {
      txt1: '学术研习，共同进步',
      txt2: '报名进行中',
      txt3: '查看更多活动',
      txt4: '高手如林，比肩接踵',
      txt5: '查看更多合集',
      txt6: '简单四步，开启精彩',
      txt7: '登录/注册',
      txt8: '登录账号操作更流畅/注册',
      txt9: '查看活动详情页',
      txt10: '查看你感兴趣的活动',
      txt11: '活动报名',
      txt12: '提交活动报名资料',
      txt13: '进入活动任务',
      txt14: '开启PBL项目式学习',
      txt15: '以梦为马，不负韶华',
      txt16: '欲戴皇冠，必承其重',
      txt17: 'BLOOM-让生命绽放',
      txt18: '一起学，一起浪',
      txt19: '探索更多有趣玩法',
      txt20: '以下活动正在进行中',
      txt21: '查看任务',
      txt22: '不再出现',
      txt23: '进入活动'
    }
  }
}

export const homeEn = {
  homeWords: {
    titles: {
      t1: 'Gathering global advanced quality education activities',
      t2: 'Communicating and collaborating with talents around the world',
      t3: 'How to apply？',
      t4: 'Talents\' Voices',
      t5: 'To discover a brand new ego',
      t6: 'Event Plaza',
      t7: 'Featured Projects'
    },
    texts: {
      txt1: 'Academic Challenge in Rush Hour ',
      txt2: 'Registration in Progress',
      txt3: 'Explore More',
      txt4: 'Clash among talents everywhere',
      txt5: 'Explore More',
      txt6: '4 Steps to Unlock Your Potential',
      txt7: 'Log In / Sign Up',
      txt8: 'Use Your Account to Run a Smooth Operation',
      txt9: 'Detailed Information about Activities',
      txt10: 'Explore More',
      txt11: 'Click here to Apply',
      txt12: 'Submit Your Application Information',
      txt13: 'Start the Task',
      txt14: 'Start Project-Based Learning from here',
      txt15: 'Seize the day and live it to the fullest',
      txt16: 'To wear crowns shall bear the heavy  ',
      txt17: 'BLOOM-Inspire Lives！',
      txt18: 'Hey，learn together，play together',
      txt19: 'Explore more',
      txt20: 'The activities below is in progress',
      txt21: 'View',
      txt22: 'No longer appear',
      txt23: 'Enter'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/home/index.js